// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bMv-k","blurredCard":"styles_blurredCard__Xlc2C"};